export type QuickAccessItem = {
  title: string;
  description: string;
  icon: string; // emoji — rendered directly in the tinted tile (not a Material Symbol)
  href: string;
  color: 'primary' | 'secondary' | 'tertiary';
};

export type ColorConfig = {
  primary: { iconBg: string; iconText: string };
  secondary: { iconBg: string; iconText: string };
  tertiary: { iconBg: string; iconText: string };
};

// Six DISTINCT top tasks (deduped IA — no two tiles share a destination).
export const QuickAccessItems: QuickAccessItem[] = [
  {
    title: 'Serviços e requerimentos',
    description:
      'Peça certidões, atestados, licenças, reservas de espaços e participações de manutenção.',
    icon: '📄',
    href: '/services',
    color: 'primary',
  },
  {
    title: 'Agenda e eventos',
    description: 'Fique a par dos eventos culturais, desportivos e reuniões públicas da freguesia.',
    icon: '📅',
    href: '/events',
    color: 'secondary',
  },
  {
    title: 'Notícias e avisos',
    description: 'Acompanhe os avisos, comunicados e destaques mais recentes da autarquia.',
    icon: '📣',
    href: '/news',
    color: 'tertiary',
  },
  {
    title: 'Documentos e editais',
    description: 'Consulte editais, atas de reuniões e documentos de transparência pública.',
    icon: '📁',
    href: '/documents',
    color: 'primary',
  },
  {
    title: 'Contactar a Junta',
    description:
      'Envie sugestões, dúvidas ou reporte ocorrências diretamente à equipa da autarquia.',
    icon: '✉️',
    href: '/contact',
    color: 'secondary',
  },
  {
    title: 'A nossa história',
    description: 'Explore a herança cultural, os monumentos e a história da freguesia.',
    icon: '📜',
    href: '/history',
    color: 'tertiary',
  },
];

export const ColorConfiguration: ColorConfig = {
  primary: { iconBg: 'bg-primary/12', iconText: 'text-primary' },
  secondary: { iconBg: 'bg-secondary/15', iconText: 'text-secondary' },
  tertiary: { iconBg: 'bg-tertiary/12', iconText: 'text-tertiary' },
};
